import { HttpClient } from '@core/gateways'
import { UnexpectedError, ValidationError } from '@core/models/errors'
import { setupIntranetV2ApiClient } from '@core/proxies/apis/intranet-v2'
import { HttpStatusCode } from '@core/types/gateways'
import {
  AtualizarRestricaoSaida,
  AlternarRestricaoSaidaStatus,
  SalvarRestricaoSaida
} from '@core/types/services'

const getValidationErrors = (body: any) => {
  return body?.errors ?? body?.Errors ?? body?.erros ?? []
}

const toApiPayload = (
  data: SalvarRestricaoSaida extends (input: infer T) => any ? T : never
) => {
  return {
    ...(data.id ? { id: data.id } : {}),
    unidade_id: data.unidadeId,
    catraca_id: data.catracaId ?? null,
    horario_minimo_saida: data.horarioMinimoSaida,
    ativo: data.ativo ?? true,
    itens: data.itens.map(item => ({
      pessoa_id: item.pessoaId ?? null,
      curso_id: item.cursoId ?? null,
      pessoa_tipo_id: item.pessoaTipoId ?? null
    }))
  }
}

export const adicionarRestricaoSaida: SalvarRestricaoSaida = async data => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: '/recepcao/restricoes-saida',
    method: 'POST',
    body: toApiPayload(data)
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return
    case HttpStatusCode.badRequest:
      throw new ValidationError(getValidationErrors(response.body))
    default:
      throw new UnexpectedError()
  }
}

export const editarRestricaoSaida: AtualizarRestricaoSaida = async data => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: `/recepcao/restricoes-saida/${data.id}`,
    method: 'PUT',
    body: toApiPayload(data)
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return
    case HttpStatusCode.badRequest:
      throw new ValidationError(getValidationErrors(response.body))
    default:
      throw new UnexpectedError()
  }
}

export const ativarRestricaoSaida: AlternarRestricaoSaidaStatus = async id => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: `/recepcao/restricoes-saida/${id}/ativar`,
    method: 'PATCH'
  })

  switch (response.statusCode) {
    case HttpStatusCode.noContent:
      return
    case HttpStatusCode.badRequest:
      throw new ValidationError(getValidationErrors(response.body))
    default:
      throw new UnexpectedError()
  }
}

export const inativarRestricaoSaida: AlternarRestricaoSaidaStatus =
  async id => {
    const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
      url: `/recepcao/restricoes-saida/${id}/inativar`,
      method: 'PATCH'
    })

    switch (response.statusCode) {
      case HttpStatusCode.noContent:
        return
      case HttpStatusCode.badRequest:
        throw new ValidationError(getValidationErrors(response.body))
      default:
        throw new UnexpectedError()
    }
  }
